import axios from 'axios';
import networkService from '../services/NetworkService';
import { useToastStore } from '../store/toast';

const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: true
});

api.interceptors.request.use(config => {
    // Dynamically set the base URL to either LAN or Internet
    config.baseURL = networkService.getActiveBaseUrl();
    
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    response => response,
    error => {
        const toastStore = useToastStore();
        
        if (error.response) {
            if (error.response.status === 401) {
                localStorage.removeItem('auth_token');
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            } else {
                // Extract exact error message from Laravel if available
                const message = error.response.data?.message || error.response.data?.error || 'An error occurred. Please try again.';
                toastStore.error(message);
            }
        } else if (error.request) {
            toastStore.error('Network error. Please check your connection.');
        } else {
            toastStore.error('An unexpected error occurred.');
        }
        
        return Promise.reject(error);
    }
);

export default api;
